import React, { useState } from "react";
import { Text, View, Image, TouchableOpacity } from "react-native";
import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { ActiveTabControler } from "../../utils/services/subject-behaviour/CommonRxjsService";

import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import AppTheme from "../../AppTheme";
import Clipboard from '@react-native-clipboard/clipboard';

import * as CommonCTA from "../../utils/widgets/CommonCTA";
import * as CommonUtils from '../../utils/services/CommonUtils';
import * as AppConstant from "../../utils/constants/AppConstants";

const SelectedOfferView = (props) => {

    const offer = props?.route?.params?.offer

    const [copyTextBg, updateTextBg] = useState(AppTheme.color.white)
    const [copyText, updateCopyText] = useState('Copy')

    return (
        <View>

            <CommonHeader title={'Offers'} navigation={props.navigation} />

            <View style={[{
                marginTop: AppTheme.headerHeight
            }]}>
                <Image style={{ height: 190, width: AppTheme.appWidth }}
                    source={{ uri: CommonUtils.getImagePath('/images/offerBanner.png') }} />
                <View style={[{
                    paddingHorizontal: 16,
                    paddingTop: 24, paddingBottom: 16
                }]}>
                    <View style={[AppStyles.flexRowSpaceBetween]}>
                        <View style={[AppStyles.flexRowStart]}>
                            <Image style={{ height: 32, width: 32 }}
                                source={{ uri: CommonUtils.getImagePath('/images/icons/order_circle_blue.svg') }} />
                            <View style={{
                                borderRadius: 4, borderWidth: 2, borderStyle: "dashed",
                                borderColor: AppTheme.color.primary, marginLeft: 12,
                                paddingVertical: 6, paddingHorizontal: 14
                            }}>
                                <Text style={[TextStyle.text14b]}>
                                    {offer.code}
                                </Text>
                            </View>
                        </View>
                        <TouchableOpacity style={{
                            backgroundColor: copyTextBg,
                            padding: 4, borderRadius: 4
                        }}
                            onPress={() => {
                                updateTextBg(AppTheme.color.blue.lightTint);
                                updateCopyText('Copied')
                                Clipboard.setString(offer.code);
                                setTimeout(() => {
                                    updateTextBg(AppTheme.color.white);
                                }, 400)
                                setTimeout(() => {
                                    updateCopyText('Copy')
                                }, 3000)
                            }}>
                            <Text style={[TextStyle.text14xb,
                            { color: AppTheme.color.primary }]}>
                                {copyText}</Text>
                        </TouchableOpacity>
                    </View>
                    <Text style={[TextStyle.text14b, { marginTop: 16 }]}>
                        {offer.title}</Text>

                    <Text style={[TextStyle.text12, { marginTop: 6 }]}>
                        {offer.subTitle}</Text>

                    <Text style={[TextStyle.text14b, { marginTop: 24 }]}>
                        Terms {AppConstant.Ampersand} Conditions</Text>

                    {offer.tnc.map((terms, index) => (
                        <View key={index}
                            style={[AppStyles.flexRowStart,
                            { marginTop: 8 }]}>
                            <View style={{
                                width: 4, height: 4, borderRadius: 4,
                                backgroundColor: AppTheme.color.black
                            }} />
                            <Text style={[TextStyle.text14, {
                                marginLeft: 16, flexWrap: "wrap",
                                color: AppTheme.color.grey.text,
                                width: AppTheme.appWidth - 60
                            }]}>
                                {terms}</Text>
                        </View>
                    ))}
                </View>
            </View>

            {
                offer.serviceName == AppConstant.ServiceName.order &&
                <View style={[AppStyles.bottomFix, { bottom: 16 }]}>
                    <CommonCTA.CommonOrderNowCTA
                        width={AppTheme.appWidth - 32}
                        navigation={props.navigation}
                    />
                </View>
            }
        </View>
    )
}

export default SelectedOfferView